export const createVorlagenService = ({ supabase }) => {
  const getPromptIdColumn = () => "id";

  const toPromptPayload = (tableNames, prompt) => {
    const promptIdColumn = getPromptIdColumn(tableNames);

    return {
      [promptIdColumn]: String(prompt?.id || prompt?.prompt_id || ""),
      name: String(prompt?.name || "").trim(),
      mod: String(prompt?.mod || "CT"),
      befund: String(prompt?.befund || ""),
      beurteilung: prompt?.beurteilung || null,
      created_at: prompt?.created_at || Date.now(),
    };
  };

  const loadBaselineRows = async (tableNames) => {
    if (!supabase) return { data: [], error: new Error("Supabase nicht konfiguriert") };
    return supabase
      .from(tableNames.vorlagen)
      .select("*")
      .order("created_at", { ascending: true });
  };

  const insertPrompt = async (tableNames, prompt) => {
    if (!supabase) return { error: new Error("Supabase nicht konfiguriert") };
    return supabase.from(tableNames.vorlagen).insert(toPromptPayload(tableNames, prompt));
  };

  const deletePromptById = async (tableNames, promptId) => {
    if (!supabase) return { error: new Error("Supabase nicht konfiguriert") };
    return supabase.from(tableNames.vorlagen).delete().eq(getPromptIdColumn(tableNames), promptId);
  };

  const upsertPrompt = async (tableNames, prompt) => {
    if (!supabase) return { error: new Error("Supabase nicht konfiguriert") };
    return supabase
      .from(tableNames.vorlagen)
      .upsert(toPromptPayload(tableNames, prompt), { onConflict: getPromptIdColumn(tableNames) });
  };

  return {
    loadBaselineRows,
    insertPrompt,
    deletePromptById,
    upsertPrompt,
  };
};
